import { useHistory, useParams ,useLocation} from "react-router-dom";
import React, { useState, useEffect } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import Select from "react-select";
//import avatar from "assets/img/faces/marc.jpg";
import isEmpty from '../../lib/isEmpty';
import  ReactHTMLParser  from "react-html-parser";

import {  addfaq } from '../../actions/users';
import {CKEditor} from 'ckeditor4-react';
const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  textDanger: {
    color: "red",
  },
};

// toaster config
toast.configure();
let toasterOption = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}


const initialFormValue = {
  'question': "",
  'answer': "",

}

const useStyles = makeStyles(styles);

export default function UserProfile() {
  const classes = useStyles();
  const history = useHistory();
  const location=useLocation()
  const Params = useParams()
  const [validateError, setValidateError] = useState({});
  const [categoryname, setCategoryname] = useState('');
 const [categorytype, setCategorytype] = useState([]);
 const [question, setquestion] = useState("");
 const [answer, setanswer] = useState("");
 const [TopContent, settopContent] = useState("");
var {from}=Params
console.log("afsdbasdfbsdf",from);
useEffect(() => {
   //getCategorytype()
  }, [])
  // function

  const onChange = (e) => {
    setquestion(e.target.value)
    console.log("question",question)
 
  }
  const onEditorChange = (evt,from) => {
    console.log("sxfgndgfhnd",evt,from);
    var description_text = evt.editor.getData() 
    console.log("setanswer",description_text)
   if(from==="top"){settopContent(description_text)}else{ setanswer(description_text);}
  }

  const handleFormSubmit = async (e) => {
console.log("dsfbdfgbzdvzsfv",e);
    e.preventDefault();
    //console.lo(formValue);
    var type=categoryname.categoryname;
    let reqData = {
        //type,
        question,
        answer,
        TopContent,
        dbname:"privacy",
        from:from
        

    }
    console.log("fgnjhfghnjfghnj",reqData)
    //console.lo(reqData);
    let { error } = await addfaq(reqData);
    //console.lo("error MSG"+ error);
    if (isEmpty(error)) {
      //console.lo("sucessfully added")
      toast.success(' added successfully', toasterOption);
      history.push('/privacyPolicyList')
    } else {
      setValidateError(error);
    }
  }

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <form className={classes.form} noValidate onSubmit={handleFormSubmit}>
              <CardHeader className='bar_bg' color="primary">
                <h4 className={classes.cardTitleWhite}>Add Privacy Policy</h4>
                <p className={classes.cardCategoryWhite}>Create a new Privacy Policy</p>
              </CardHeader>
              <CardBody>


              {from==="top"&&
<GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <label>Top Content</label>
                      {
                        
                      <CKEditor
                            // value={answer}
                            // data={}
                            initData={<p>{ReactHTMLParser(TopContent)}</p>}
                            id="TopContent"
                            onChange={(e)=>onEditorChange(e,"top")}
                        />
                        }
                    {
                      validateError.TopContent && <span className={classes.textDanger}>{validateError.TopContent}</span>
                    }
                  </GridItem>
                </GridContainer>
}
{from!=="top"&&
                  <GridContainer>                 
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Question"
                        onChange={onChange}
                        id="question"
                        value={question||''}
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                      {
                          validateError.question && <span className="text-danger">{validateError.question}</span>
                      }
                    </GridItem>
                    
                  </GridContainer>
                  }
              <p>Answer</p>
               { from!=="top"&&  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      {/* <CustomInput
                        labelText="Answer"
                        id="answer"
                        onChange={onChange}
                        value={answer || ''}
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          multiline: true,
                          rows: 5
                        }}
                      /> */}
                       <CKEditor
                            value={answer||''}
                            data=""
                            onChange={(e)=>onEditorChange(e,"QA")}                        />
                   
                    {
                      validateError.answer && <span className="text-danger">{validateError.answer}</span>
                    }
                  </GridItem>
                </GridContainer>}
                 {/*<GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                <Select
                        onChange={handleChange}
                        options={categorytype}
                        label="select type"
                         formControlProps={{
                        fullWidth: true
                      }}
                      />
              </GridItem>
                </GridContainer>*/}
              </CardBody>
              <CardFooter>
                <Button className='cmn_btn_bg' type="submit">Add</Button>
              </CardFooter>
            </form>
          </Card>
        </GridItem>       
      </GridContainer>
    </div>
  );
}
